import React from 'react'
import KioskMap from '../../components/UI/KioskMap/KioskMap'
import FetchData from '../../shared/fetchData'
import Select from '../../components/UI/Select/Select'

const KioskDetails = (props) => {

    const [latitude, setLatitude] = React.useState(35.7575)
    const [longitude, setLongitude] = React.useState(51.4099)
    const [zoom, setZoom] = React.useState(12)
    const [kioskDetails, setKioskDetails] = React.useState([])
    const [proviances, setProviances] = React.useState([]);
    const [geoNames, setGeoNames] = React.useState([]);
    const [proviance, setProviance] = React.useState('');
    const [geoName, setGeoName] = React.useState('');
    const [kiosk, setKiosk] = React.useState('');

    React.useEffect(() => {
        var info = {
            "geoName": {
                "type": "PRV"
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/geonames/getGeoNames'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setProviances(result.geoNames);
            })
            .catch(error => console.log(error))
        var info = {
            "finalized": "1",
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/kiosks/getAllKiosksWithDetails'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setKioskDetails(result.kiosks)
            })
            .catch(error => console.log('error', error))
    }, [])

    const changeMapHandler = (event) => {
        let lat = event.target.getCenter().lat
        let lng = event.target.getCenter().lng
        let zoom = event.target.getZoom()
        setLatitude(lat)
        setLongitude(lng)
        setZoom(zoom)
    }
    const changeLocation = (lat, lng) => {
        setLatitude(lat)
        setLongitude(lng)
    }
    const provianceChange = (value) => {
        setProviance(value);
        var info = {
            "geoName": {
                "type": "CTY",
                "parentId": value?.value
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/geonames/getGeoNames'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setGeoNames(result.geoNames);
            })
            .catch(error => console.log(error))
    }
    const geoNameChange = (value) => {
        setLatitude(parseFloat(value.lat))
        setLongitude(parseFloat(value.lon))
        setGeoName(value);
    }
    let provianceList = []
    if (proviances != null && proviances.length != 0) {
        let prvns = [...proviances]
        prvns.map(b => {
            provianceList.push({
                value: b.id,
                label: b.description
            })
        })
    }
    let geoNameList = []
    if (geoNames != null && geoNames.length != 0) {
        let gnms = [...geoNames]
        gnms.map(b => {
            geoNameList.push({
                value: b.id,
                lat: b.lat,
                lon: b.lon,
                label: b.description
            })
        })
    }
    return (
        <div>
            <div className='row justify-content-center w-100 ml-0 mr-0' >
                <Select
                    name="form-field-name"
                    value={proviance}
                    placeholder="استان"
                    options={provianceList}
                    className="map-geo"
                    onChange={provianceChange}
                    col="4 mt-3"
                />
                <Select
                    name="form-field-name"
                    value={geoName}
                    placeholder="شهر"
                    className="map-geo"
                    options={geoNameList}
                    onChange={geoNameChange}
                    col="4 mt-3"
                />
            </div>
            <KioskMap
                lat={latitude}
                lng={longitude}
                kiosks={kioskDetails}
                kiosk={kiosk}
                changeLocationOnKiosk={(value) => { setZoom(22); setLatitude(value.lat); setLongitude(value.lon); setKiosk(value) }}
                zoom={zoom}
                latLngChangeHandler={changeMapHandler}
                changeLocation={changeLocation}
            />
        </div>
    )
}

export default KioskDetails